import { render, staticRenderFns } from "./EditDocumentLibrary.vue?vue&type=template&id=1523b358"
import script from "./EditDocumentLibrary.vue?vue&type=script&lang=js"
export * from "./EditDocumentLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports